import script from "./pointSummary.vue?vue&type=script&lang=ts&setup=true"
export * from "./pointSummary.vue?vue&type=script&lang=ts&setup=true"

import "./pointSummary.vue?vue&type=style&index=0&id=d2106cae&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2106cae"]])

export default __exports__